import { useEffect, useState } from 'react';
import { formatCredits, type GameStage, type Minor } from '@mt/protocol';
import { client } from '../net/client';

export const cr = (m: Minor) => formatCredits(m);
/** Сумма без «кр.» — для таблиц, где единица указана в заголовке столбца. */
export const crn = (m: Minor) => formatCredits(m).replace(/\u00a0кр\.$/, '');

export function pts(x: number | null | undefined, signed = false): string {
  if (x === null || x === undefined) return '—';
  const s = Math.abs(x).toFixed(2).replace('.', ',');
  if (!signed) return (x < 0 ? '−' : '') + s;
  return (x > 0 ? '+' : x < 0 ? '−' : '±') + s;
}

export function secondsLeft(until: number | null, now: number): number | null {
  if (until === null) return null;
  return Math.max(0, Math.ceil((until - now) / 1000));
}

export function clock(t: number): string {
  return new Date(t).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

/** Серверное «сейчас», перерисовка каждые 250 мс. */
export function useNow(intervalMs = 250): number {
  const [now, setNow] = useState(() => client.now());
  useEffect(() => {
    const id = setInterval(() => setNow(client.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

export const STAGE_TITLES: Record<GameStage, string> = {
  prep: 'Подготовка',
  round1: 'Круг 1 · график и направление',
  round2: 'Круг 2 · шкала цен',
  round3: 'Круг 3 · состав и пункты',
  locked: 'Ожидание закрытия свечи',
  settled: 'Расчёт',
  cancelled: 'Отменён',
};

export const ACTION_TITLES: Record<string, string> = {
  ante: 'взнос',
  fold: 'пас',
  check: 'чек',
  call: 'колл',
  bet: 'ставка',
  raise: 'райз',
  allin: 'олл-ин',
};
